"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'dblogs.error.fetch': 'Nie udało się załadować logów.',
};
